<template>
  <div class="data-grid-data-cascader">
    <el-cascader v-model="selectValue"
                 :options="columnOptions"
                 :props="cascaderProps"
                 :filterable="true"
                 popper-class="data-grid-data-cascader-popper"
                 @visible-change="expandGridCascaderData"
                 style="width: 100%">
    </el-cascader>
  </div>
</template>

<script>
import baseApiUrl from '../../../constants/baseApiUrl'
import routeConfig from '../../../constants/routeConfig'
export default {
  name: 'DataGridDataCascader',
  props: {
    value: {
      required: true
    },
    column: {
      type: Object,
      required: true
    },
    valueProp: {
      type: String,
      required: true
    },
    labelProp: {
      type: String,
      required: true
    },
    childrenProp: {
      type: String,
      required: true
    },
    refOptions: {
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      loading: false,
      fetched: false,
      optionList: null
    }
  },
  computed: {
    cascaderProps () {
      return {
        value: this.valueProp,
        label: this.labelProp,
        children: this.childrenProp,
        emitPath: false
      }
    },
    columnOptions: function () {
      let optionList = this.optionList
      if (!optionList) {
        if (Array.isArray(this.refOptions)) {
          optionList = this.refOptions
        }
      }
      return optionList
    },
    selectValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    // 展开级联框
    expandGridCascaderData (visible) {
      if (!visible) {
        return
      }
      if (!this.loading && !this.fetched) {
        let postParams = this.$extend(this.$attrs)
        if (!postParams[routeConfig.DataGrid.param]) {
          return
        }
        this.loading = true
        const loadingOption = {
          [this.labelProp]: '数据加载中...',
          [this.valueProp]: '数据加载中...',
          disabled: true
        }
        this.optionList = [loadingOption]
        let params = this.$extend({
          requestType: 'cascader',
          prop: this.column.prop
        }, postParams)
        this.$ajax({
          url: baseApiUrl.DataGridUrl,
          method: 'post',
          data: this.$qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        }).then((response) => {
          if (response.data) {
            this.optionList = response.data['optionList']
            if (response.data['message'] && response.data['responseCode'] !== 'SUCCESS') {
              this.$message.error('级联数据加载出错')
            }
          }
          this.fetched = true
        }).catch(() => {
          this.optionList = null
        }).finally(() => {
          this.loading = false
        })
      }
    }
  },
  deactivated () {
    // 切换页面后重新加载
    this.fetched = false
  }
}
</script>

<style lang="scss">
  .data-grid-data-cascader {
    &>.el-cascader {
      width: 100%;
      .el-input--mini {
        .el-input__inner {
          height: 28px!important;
        }
      }
      .el-input--small {
        .el-input__inner {
          height: 32px!important;
        }
      }
      .el-input--medium {
        .el-input__inner {
          height: 36px!important;
        }
      }
      .el-cascader__tags {
        .el-cascader__search-input {
          min-width: 30px;
        }
      }
    }
  }
  .el-cascader__dropdown {
    &.data-grid-data-cascader-popper {
      .el-cascader-menu__wrap {
        .el-cascader-menu__list {
          .el-cascader-node {
            .el-cascader-node__label {
              font-size: 13px;
            }
            .el-checkbox {
              .el-checkbox__input {
                vertical-align: -2px;
              }
            }
          }
          .el-cascader-menu__empty-text {
            font-size: 13px;
          }
        }
      }
    }
  }
</style>
